import {http, HttpResponse} from 'msw';
import {SetupServerApi} from 'msw/lib/node';

import {GetDirectSaleVariantsResponse} from '../types';

const getDirectSaleVariantsResponseMock: GetDirectSaleVariantsResponse = [
  {
    directSaleVariantId: '88f74ea3-e6ce-4db0-8cf2-0104b1332679',
    name: 'a[HCZ] Basic sale price for articles, price ratio 0.5, commercial labour rates. Min margin 0.1',
    isActive: true,
  },
  {
    directSaleVariantId: 'af6dca31-cca2-4048-94eb-079c57ee6dbb',
    name: 'bJS DS VAR',
    isActive: true,
  },
  {
    directSaleVariantId: '55b17e83-4ea9-46e9-8eac-4de1c416e784',
    name: 'c[MERCZ] Recommended price for articles,  price ratio 1.0, commercial labour rates',
    isActive: true,
  },
  {
    directSaleVariantId: '57dfc221-0516-46b9-93f2-d845e47b365e',
    name: '[HCZ] Basic sale price for articles, price ratio 1.0, commercial labour rates',
    isActive: true,
  },
  {
    directSaleVariantId: '1f298c5a-df09-4abe-ba61-57b7b0f2a66e',
    name: '[HCZ] Basic sale price for articles, price ratio 2.0, commercial labour rates',
    isActive: true,
  },
  {
    directSaleVariantId: 'e7694c31-23f4-4a0d-a356-e0ca26c873d8',
    name: '[HCZ] Purchase price for articles, price ratio 1.0, internal labour rate',
    isActive: true,
  },
  {
    directSaleVariantId: 'a8ef5382-2b94-4b5f-9699-a59a7d412915',
    name: '[HCZ] Recommended price for articles,  price ratio 1.0, commercial labour rates',
    isActive: true,
  },
  {
    directSaleVariantId: '7fe62930-bb7f-4322-8750-92242b57c971',
    name: '[HCZ] Warranty price for articles, price ratio 1.0, warranty labour rate',
    isActive: true,
  },
  {
    directSaleVariantId: '3fbe440a-8cb2-48be-9e71-1d93f390db00',
    name: '[HPL] Maciej Test Basic sale price for articles, price ratio 1.0, commercial labour rates',
    isActive: true,
  },
  {
    directSaleVariantId: '68cfe180-165d-4b3d-9838-59fe8ff1a733',
    name: '[HSK] Basic sale price for articles, price ratio 1.0, commercial labour rates',
    isActive: true,
  },
  {
    directSaleVariantId: 'c6eee961-7dc8-4515-8679-b1045cc9b145',
    name: '[HSK Other] Basic sale price for articles price ratio 1.0, commercial labour rates',
    isActive: true,
  },
  {
    directSaleVariantId: '3ba112b4-e77f-47c8-b1c6-f85f953f68d5',
    name: 'Js Test',
    isActive: true,
  },
  {
    directSaleVariantId: '360a7895-d1d9-4441-b99e-99123cf9fdb4',
    name: '[MERCZ] Warranty price for articles, price ratio 1.0, warranty labour rate',
    isActive: true,
  },
];

const getDirectSaleVariantsResponseInterceptor = (server: SetupServerApi) =>
  server.use(
    http.get('*/warehouse/v2/direct-sale-variants', () =>
      HttpResponse.json(getDirectSaleVariantsResponseMock)
    )
  );

export const metadaWarehouseDirectSaleVariantApiMock = {
  getDirectSaleVariantsResponseMock,
  getDirectSaleVariantsResponseInterceptor,
};
